// src/features/boe/components/programs/Program1100.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_1100_CONFIG = {
  fullName: "P.A.C.E.",
  docId: "1100",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsTeachers",
      label: "Positions – Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesTeachers",
      label: "Salaries – Teachers",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Teachers" }],
      group: "salaries",
      defaultVisible: false,
    },

    // Field Trips (can appear under Salaries or Supplies / Materials in some years)
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Field Trips" },
        { block: "Supplies / Materials", key: "Field Trips" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials" },
        {
          block: "Supplies / Materials",
          key: "Instructional Materials (English)",
        },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "duesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues and Fees" },
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues / Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        "positionsTeachers",
        "salariesTeachers",
        "instructionalMaterials",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesTeachers: { minWidth: "110px" },
        teacherAverageSalary: { minWidth: "130px" },
        fieldTrips: { minWidth: "90px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "120px" },
        duesFees: { minWidth: "110px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        "positionsTeachers",
        "salariesTeachers",
        "instructionalMaterials",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesTeachers: { minWidth: "110px" },
        teacherAverageSalary: { minWidth: "130px" },
        fieldTrips: { minWidth: "90px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "120px" },
        duesFees: { minWidth: "110px" },
      },
    },
  ],
};

export function Program1100(props) {
  return (
    <ProgramBudget programId="1100" config={PROGRAM_1100_CONFIG} {...props} />
  );
}
